var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"battles-banner",attrs:{"target":"_blank","href":_vm.link}},[_c('img',{staticClass:"battles-banner__gif",attrs:{"src":"gifs/bnr-2025.gif"}})])}
var staticRenderFns = []

export { render, staticRenderFns }